<form class="change-password-form" #changePasswordForm="ngForm">
  <div class="change-password-form-inner-container">
    <div class="p-fluid">
      <div class="p-field mt-0">
        <label>{{ 'Current Password' | translate }}</label>
        <input
          type="password"
          name="currentPassword"
          pInputText
          [placeholder]="'Current Password' | translate"
          [(ngModel)]="currentPassword"
          required
          #currentPasswordDom="ngModel"
        />
        <small
          class="p-error"
          *ngIf="
            currentPasswordDom.invalid &&
            (currentPasswordDom.dirty ||
              currentPasswordDom.touched) &&
            currentPasswordDom.errors?.required
          "
        >
          {{ '{field} must not be blank!' | translate:{ field:'Current Password' | translate } }}
        </small>
      </div>
      <div class="p-field">
        <label>{{ 'New Password' | translate }}</label>
        <input
          type="password"
          name="newPassword"
          pInputText
          [placeholder]="'New Password' | translate"
          required
          minlength="8"
          maxlength="256"
          [(ngModel)]="newPassword"
          sigvPasswordComplexity
          #newPasswordDom="ngModel"
        />
        <ng-container
          *ngIf="
            newPasswordDom.invalid &&
            (newPasswordDom.dirty || newPasswordDom.touched)
          "
        >
          <small
            class="p-error"
            *ngIf="newPasswordDom.errors?.required"
          >
          {{ '{field} must not be blank!' | translate:{ field:'New Password' | translate } }}
          </small>

          <small
            class="p-error"
            *ngIf="newPasswordDom.errors?.passwordComplixity"
          >
            {{ 'Your password must be at least 8 characters long, include a number, an uppercase letter, a lowercase letter, and a special character.' | translate }}
          </small>
        </ng-container>
      </div>
      <div class="p-field">
        <label>{{
          "Confirm New Password" | translate
        }}</label>
        <input
          type="password"
          name="confirmNewPassword"
          [placeholder]="
            'Confirm New Password' | translate
          "
          pInputText
          [(ngModel)]="confirmPassword"
          required
          [appEqualTo]="newPassword"
          #confirmPasswordDom="ngModel"
        />
        <small
          class="p-error"
          *ngIf="
            confirmPasswordDom.invalid &&
            (confirmPasswordDom.dirty ||
              confirmPasswordDom.touched) &&
            confirmPasswordDom.errors?.required
          "
        >
        {{ '{field} must not be blank!' | translate:{ field:'Confirm New Password' | translate } }}
        </small>
        <small
          class="p-error"
          *ngIf="
            confirmPasswordDom.invalid &&
            (confirmPasswordDom.dirty ||
              confirmPasswordDom.touched) &&
            confirmPasswordDom.errors?.equalTo
          "
        >
          {{ 'The passwords do not match.' | translate }}
        </small>
      </div>
      <div *ngIf="elementControlJSON.Login.GoogleReCaptcha.display" class="p-field">
        <re-captcha
          name="captcha"
          class="p-d-flex p-jc-center"
          (error)="onRecaptchaError($event)"
          errorMode="handled"
          [(ngModel)]="recaptchaToken"
          required
          [siteKey]="envConfig.recaptchaSiteKey"
        ></re-captcha>
      </div>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-6">
      <div class="button pv-0 ph-0">
        <a
          role="button"
          href="javascript: void(0)"
          class="btn btn-secondary"
          (click)="onClearBtnClick(changePasswordForm)"
          >{{ 'Clear' | translate }}</a
        >
      </div>
    </div>
    <div class="p-col-6">
      <div class="button pv-0 ph-0">
        <a
          href="javascript: void(0)"
          class="btn btn-primary"
          (click)="onFormSubmit(changePasswordForm)"
          >{{ 'Submit' | translate }}</a
        >
      </div>
    </div>
  </div>
</form>
